const dropdowns = {

    init: function () {
        let dropdowns = document.querySelectorAll('[data-dropdown-js]');
        if (!dropdowns || dropdowns.length === 0) return;

        dropdowns.forEach((dropdown) => {
            this.initDropdown(dropdown);
        });
    },

    initDropdown: function (dropdown) {
        if (!dropdown) return;

        let dropdownTrigger = dropdown.querySelector('[data-dropdown-trigger-js]');

        dropdownTrigger.addEventListener("click", event => {
            event.preventDefault();
            toggle(dropdown);
        });

        function toggle(target) {
            if (target.classList.contains('is-active')) {
                close(target);
            } else {
                open(target);
            }
        }

        function close(target) {
            let targetInner = target.querySelector('[data-dropdown-inner-js]');
            if (!targetInner) return;

            setHeight(targetInner);

            target.classList.remove("is-active");

            setTimeout(() => {
                targetInner.style.height = null;
            }, 0);
        }

        function open(target) {
            let targetInner = target.querySelector('[data-dropdown-inner-js]');
            if (!targetInner) return;

            setTimeout(() => {
                setHeight(targetInner);
                target.classList.add("is-active");
            }, 0);
        }

        function setHeight(target) {
            target.style.height = target.scrollHeight + "px";
        }

    }
}

export default dropdowns;